(() => {
  const root = document.querySelector('.ams-rewards');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';
  const copy = JSON.parse(root.querySelector('[data-ams-copy]').textContent);
  const signedIn = root.dataset.signedIn === 'true';
  const el = id => root.querySelector(`#${id}`);
  const source = root.querySelector('.ams-native-source');
  const shopUrl = root.dataset.shopUrl;
  const signInUrl = root.dataset.signInUrl;
  const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', { maximumFractionDigits: 2 });
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency', currency: root.dataset.currency || 'USD', maximumFractionDigits: Number.isInteger(value) ? 0 : 2
  }).format(value);
  const text = (key, values = {}) => Object.entries(values).reduce((result, [name, value]) => result.replaceAll(`[[${name}]]`, value), copy[key]);
  let signature = '';
  let frame = 0;
  let pendingDialog = false;
  let dialogSeen = false;
  let dismissalRequested = false;
  let closeTimer = 0;
  let openingTimer = 0;
  let reloadRequested = false;
  let returnFocus = null;
  let returnRewardCost = null;
  const balance = () => {
    if (!signedIn) return null;
    const value = source.querySelector('.Joy-Hero-Banner_Title')?.textContent.trim();
    if (!value || !/^[\d,\s]+(?:\.\d+)?$/.test(value)) return null;
    const parsed = Number(value.replace(/[\s,]/g, ''));
    return Number.isFinite(parsed) && parsed >= 0 ? parsed : null;
  };
  const programs = () => Array.from(source.querySelectorAll('.Joy-Redeem__Item-Button')).flatMap(native => {
    const label = native.querySelector('.Joy-Way-To-Redeem__Item-SubTitle')?.textContent.trim() || '';
    const match = label.match(/Discount\s+[^\d]*([\d,.]+)\s+for\s+([\d,.]+)\s+points/i);
    if (!match) return [];
    const amount = Number(match[1].replaceAll(',', ''));
    const cost = Number(match[2].replaceAll(',', ''));
    return Number.isFinite(amount) && amount > 0 && Number.isFinite(cost) && cost > 0 ? [{ amount, cost, native }] : [];
  }).sort((a, b) => a.cost - b.cost || a.amount - b.amount);
  const visible = node => Boolean(node && node.getClientRects().length && node.getAttribute('aria-hidden') !== 'true' && getComputedStyle(node).visibility !== 'hidden');
  const hasNativeDialog = () => Array.from(document.querySelectorAll('.Avada-LoyaltyPage__Modal')).some(visible);
  const restoreFocus = () => {
    if (!document.contains(root)) return;
    const original = returnFocus?.isConnected && !returnFocus.disabled ? returnFocus : null;
    const replacement = returnRewardCost === null ? null : el(`reward-${returnRewardCost}`)?.querySelector('.card-action');
    const target = original || replacement || el('main-cta');
    if (target && !target.disabled) target.focus({ preventScroll: true });
  };
  const finishWithoutReload = () => {
    clearTimeout(closeTimer);
    clearTimeout(openingTimer);
    closeTimer = 0;
    openingTimer = 0;
    pendingDialog = false;
    dialogSeen = false;
    dismissalRequested = false;
    reloadRequested = false;
    signature = '';
    refresh();
    restoreFocus();
  };
  const openProgram = (cost, amount, trigger) => {
    if (pendingDialog || hasNativeDialog()) return;
    const current = programs().find(program => program.cost === cost && program.amount === amount);
    const points = balance();
    if (!current || points === null || points < current.cost) {
      signature = '';
      refresh();
      return;
    }
    pendingDialog = true;
    dialogSeen = false;
    dismissalRequested = false;
    returnFocus = trigger;
    returnRewardCost = cost;
    openingTimer = window.setTimeout(() => {
      openingTimer = 0;
      if (!dialogSeen && !hasNativeDialog()) finishWithoutReload();
      else requestRefresh();
    }, 5000);
    try {
      current.native.click();
    } catch {
      finishWithoutReload();
      return;
    }
    requestRefresh();
  };
  const setHero = (points, rewards) => {
    const best = points === null ? null : rewards.filter(program => points >= program.cost).at(-1);
    const next = rewards.find(program => points === null || points < program.cost);
    el('member-copy').hidden = !signedIn;
    el('guest-copy').hidden = signedIn;
    el('ready-badge').hidden = !best;
    el('progress-wrap').hidden = !signedIn || points === null || Boolean(best) || !next;
    root.querySelector('.hero-copy').classList.toggle('has-reward', Boolean(best));
    el('balance').textContent = best ? text('reward_ready', { reward: money(best.amount) }) : points === null ? copy.points_loading : text('points_balance', { points: formatter.format(points) });
    el('member-description').textContent = best ? text('ready_description', { points: formatter.format(points), reward: money(best.amount) }) : points === null ? copy.loading_description : copy.keep_earning;
    if (next && points !== null) {
      el('progress').setAttribute('aria-valuemax', String(next.cost));
      el('progress').setAttribute('aria-valuenow', String(Math.min(points, next.cost)));
      el('progress').setAttribute('aria-label', text('progress_label', { reward: money(next.amount) }));
      el('progress-fill').style.width = `${Math.min(points / next.cost * 100, 100)}%`;
      el('progress-note').textContent = text('points_remaining', { points: formatter.format(Math.max(next.cost - points, 0)), reward: money(next.amount) });
    }
    el('main-cta').textContent = best ? pendingDialog ? copy.checking : text('redeem_my_reward', { reward: money(best.amount) }) : copy.shop_now;
    el('main-cta').href = best ? `#reward-${best.cost}` : shopUrl;
    if (best && pendingDialog) el('main-cta').setAttribute('aria-disabled', 'true');
    else el('main-cta').removeAttribute('aria-disabled');
    el('secondary-cta').textContent = !signedIn ? copy.sign_in_join : best ? copy.shop_now : points === null ? copy.view_rewards : copy.see_rewards;
    el('secondary-cta').href = !signedIn ? signInUrl : best ? shopUrl : points === null ? '#joy-ways-to-redeem' : '#rewards';
  };
  const setCards = (points, rewards) => {
    const grid = root.querySelector('.rewards-grid');
    grid.setAttribute('aria-busy', String(pendingDialog));
    if (!rewards.length) {
      grid.classList.remove('has-ready');
      grid.replaceChildren();
      const fallback = document.createElement('p');
      fallback.className = 'ams-reward-fallback';
      const link = document.createElement('a');
      link.className = 'text-link';
      link.href = signedIn ? '#joy-ways-to-redeem' : signInUrl;
      link.textContent = signedIn ? copy.view_rewards : copy.sign_in_join;
      fallback.append(link);
      grid.append(fallback);
      return;
    }
    grid.classList.toggle('has-ready', signedIn && points !== null && rewards.some(program => points >= program.cost));
    const cards = rewards.map(program => {
      const ready = signedIn && points !== null && points >= program.cost;
      const locked = signedIn && points !== null && !ready;
      const card = document.createElement('article');
      card.id = `reward-${program.cost}`;
      card.className = `reward-card${ready ? ' is-ready' : locked ? ' is-locked' : ''}`;
      const label = document.createElement('p');
      label.className = 'card-label';
      label.textContent = !signedIn ? copy.sign_in_check : ready ? copy.ready_label : locked ? copy.locked : copy.checking;
      const heading = document.createElement('h3');
      heading.textContent = text('amount_off', { reward: money(program.amount) });
      const price = document.createElement('p');
      price.className = 'points-price';
      price.textContent = text('points_price', { points: formatter.format(program.cost) });
      const status = document.createElement('p');
      status.className = 'reward-status';
      if (ready) {
        const button = document.createElement('button');
        button.className = 'card-action';
        button.type = 'button';
        button.textContent = pendingDialog ? copy.checking : text('redeem_reward', { reward: money(program.amount) });
        button.disabled = pendingDialog;
        button.addEventListener('click', event => openProgram(program.cost, program.amount, event.currentTarget));
        status.append(button);
      } else {
        status.textContent = !signedIn ? copy.sign_in_points : points === null ? copy.checking : text('points_needed', { points: formatter.format(Math.max(program.cost - points, 0)) });
      }
      card.append(label, heading, price, status);
      return card;
    });
    grid.replaceChildren(...cards);
  };
  const refresh = () => {
    frame = 0;
    const dialogOpen = hasNativeDialog();
    if (dialogOpen) {
      if (!pendingDialog) {
        pendingDialog = true;
        returnFocus = root.contains(document.activeElement) ? document.activeElement : null;
        returnRewardCost = null;
      }
      dialogSeen = true;
      clearTimeout(openingTimer);
      openingTimer = 0;
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = 0;
        dismissalRequested = false;
      }
    } else if (pendingDialog && dialogSeen && !closeTimer && !reloadRequested) {
      closeTimer = window.setTimeout(() => {
        closeTimer = 0;
        if (hasNativeDialog()) {
          dismissalRequested = false;
          requestRefresh();
          return;
        }
        if (document.contains(root) && location.pathname.replace(/\/$/, '') === root.dataset.pagePath) {
          try {
            reloadRequested = true;
            location.reload();
          } catch {
            finishWithoutReload();
          }
        } else {
          finishWithoutReload();
        }
      }, dismissalRequested ? 750 : 1800);
    }
    const points = balance();
    const rewards = programs();
    const nextSignature = JSON.stringify([points, pendingDialog, rewards.map(({ amount, cost }) => [amount, cost])]);
    if (signature !== nextSignature) {
      signature = nextSignature;
      setHero(points, rewards);
      setCards(points, rewards);
    }
  };
  function requestRefresh() {
    if (!frame) frame = requestAnimationFrame(refresh);
  }
  el('signup-earn').hidden = signedIn;
  root.querySelector('.earn-grid').classList.toggle('is-member', signedIn);
  el('join-step-title').textContent = signedIn ? copy.already_joined : copy.join_free;
  el('join-step-copy').textContent = signedIn ? copy.keep_account : copy.join_description;
  el('redeem-note').textContent = signedIn ? copy.member_redeem_note : copy.guest_redeem_note;
  el('redemption-help').textContent = signedIn ? copy.member_redeem_help : copy.guest_redeem_help;
  el('main-cta').addEventListener('click', event => {
    if (pendingDialog && el('main-cta').getAttribute('aria-disabled') === 'true') event.preventDefault();
  });
  document.addEventListener('click', event => {
    if (pendingDialog && event.target instanceof Element && event.target.closest('.Avada-LoyaltyPage__Modal .close-button')) {
      dismissalRequested = true;
      requestRefresh();
    }
  }, true);
  document.addEventListener('keydown', event => {
    if (pendingDialog && event.key === 'Escape' && hasNativeDialog()) {
      dismissalRequested = true;
      requestRefresh();
    }
  }, true);
  const observer = new MutationObserver(requestRefresh);
  observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] });
  window.addEventListener('joy:ready', requestRefresh);
  window.addEventListener('pageshow', requestRefresh);
  refresh();
})();
